import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/server-bg.mp4';
import InfraCloudImg from '../../../assets/images/infracloud.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionInfraCloud.css';

const IntroSectionInfraCloud2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-infra-cloud-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('infraCloud.section1.title', 'Conception sur mesure')}</h2>
            <h3>{t('infraCloud.section1.description', 'IT Monkeys met son savoir-faire au service de vos ambitions. Notre équipe d\'experts conçoit, déploie et optimise l\'infrastructures dont votre entreprise a besoin.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('infraCloud.video.notSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('infraCloud.section2.title', 'Accompagnement')}</h2>
            <h3>{t('infraCloud.section2.description', 'Nous vous accompagnons à chaque étape. De l\'évaluation de vos besoins métier à la mise en production, en passant par la sécurisation de vos données et l\'automatisation des processus.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={InfraCloudImg}
              alt={t('infraCloud.section2.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('infraCloud.section3.title', 'Une technologie adaptée à vos besoins.')}</h2>
              <h3>{t('infraCloud.section3.description', 'Contrairement à un serveur traditionnel, le NAS est principalement focalisé sur la fonction de stockage, avec une interface de gestion souvent plus simple et des fonctionnalités préintégrées pour la sauvegarde, le partage, la sécurité et la synchronisation des données.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('infraCloud.section3.imageAlt', 'Azure OpenAI')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionInfraCloud2;
